import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const hintStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: 0.78125rem;
	line-height: 1.55;
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly children: React.ReactNode;
};

/** A muted explanation under a field or a section title. */
const HintText: React.FC<Props> = ({ children }) => {
	return <p css={hintStyle}>{children}</p>;
};

export default HintText;
